import script from "./UserAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAuth.vue?vue&type=script&setup=true&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=23c89186&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c89186"]])

export default __exports__